/**
 * Auth Layout
 *
 * Minimal layout for authentication pages (login, signup, etc.)
 * No header navigation, just logo and centered content
 */

import React from "react";
import { Link } from "react-router-dom";
import "./AuthLayout.scss";

const AuthLayout = ({ children, title, subtitle }) => {
  return (
    <div className="auth-layout">
      <div className="auth-container">
        <div className="auth-logo">
          <Link to="/">
            <img
              src="/logo.png"
              alt="ClozeSure"
              className="logo-image"
              onError={(e) => {
                e.target.style.display = "none";
                e.target.nextSibling.style.display = "block";
              }}
            />
            <span className="logo-text" style={{ display: "none" }}>
              ClozeSure
            </span>
          </Link>
        </div>

        {title && (
          <div className="auth-header">
            <h1 className="auth-title">{title}</h1>
            {subtitle && <p className="auth-subtitle">{subtitle}</p>}
          </div>
        )}

        <div className="auth-content">{children}</div>

        <div className="auth-footer">
          <p>
            &copy; {new Date().getFullYear()} ClozeSure. All rights reserved.
          </p>
        </div>
      </div>
    </div>
  );
};

export default AuthLayout;
